import React from "react";
import QCTemplateBuilder from "./QCTemplateBuilder";

export default function QCTemplateCreate() {
  return <QCTemplateBuilder mode="create" />;
}
